import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { BounceAnalyticsResponse, IspStats, PaginatedResponse } from '@/lib/types'

interface BounceParams {
  from?: string
  to?: string
}

const BOUNCES_KEY = ['analytics', 'bounces'] as const
const ISP_KEY = ['analytics', 'isps'] as const

export function useBounceAnalytics(
  params?: BounceParams,
): ReturnType<typeof useQuery<BounceAnalyticsResponse>> {
  return useQuery({
    queryKey: [...BOUNCES_KEY, params],
    queryFn: () =>
      apiClient.get<BounceAnalyticsResponse>(
        endpoints.analytics.bounces({ from: params?.from, to: params?.to }),
      ),
  })
}

export function useIspStats(
  params?: BounceParams,
): ReturnType<typeof useQuery<PaginatedResponse<IspStats>>> {
  return useQuery({
    queryKey: [...ISP_KEY, params],
    queryFn: () =>
      apiClient.get<PaginatedResponse<IspStats>>(
        endpoints.analytics.isps({ from: params?.from, to: params?.to }),
      ),
  })
}
